import { CommonFnCallMessage, EventStreamSettings, Fn } from "../../types";
import { MessageComponent, MessageComponentProps } from "./Message";

export const FunctionCall = ({
  fn,
  displaySettings,
}: {
  fn: Fn;
  displaySettings?: EventStreamSettings;
}) => {
  return (
    <code style={{ whiteSpace: "pre-wrap" }}>
      {fn.name}(
      {Object.keys(fn.args)
        .map((argName) => {
          const prettyValue = JSON.stringify(
            fn.args[argName],
            null,
            !displaySettings || displaySettings.showMessageWhitespace ? 2 : 0
          );
          return `${argName}=${prettyValue}`;
        })
        .join(", ")}
      )
    </code>
  );
};

const FnCallMessage: MessageComponent<CommonFnCallMessage> = ({
  message,
  displaySettings,
}: MessageComponentProps<CommonFnCallMessage>) => {
  const functionCall = message.function_call;
  return <FunctionCall fn={functionCall} displaySettings={displaySettings} />;
};

export default FnCallMessage;
